// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2PcKd","file":"styles_file__2d728"};